import { combineReducers } from 'redux';

import commonReducer from 'modules/common/reducer';
import generalReducer from 'modules/general/reducer';
import postsReducer from 'modules/posts/reducer';
import doctorsReducer from 'modules/doctors/reducer';
import companiesReducer from 'modules/companies/reducer';
import companyActivationReducer from 'modules/companyActivation/reducer';
import circlesReducer from 'modules/circles/reducer';
import profilesReducer from 'modules/profiles/reducer';
import accountManagementReducer from 'modules/accountManagement/reducer';

export default combineReducers({
  common: commonReducer,
  general: generalReducer,
  posts: postsReducer,
  doctors: doctorsReducer,
  companies: companiesReducer,
  companyActivation: companyActivationReducer,
  circles: circlesReducer,
  profiles: profilesReducer,
  accountManagement: accountManagementReducer,
});
